import { render, staticRenderFns } from "./customerusetotal.vue?vue&type=template&id=49b4971e&"
import script from "./customerusetotal.vue?vue&type=script&lang=ts&"
export * from "./customerusetotal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "customerusetotal.vue"
export default component.exports